import { render, staticRenderFns } from "./insertstore.vue?vue&type=template&id=c9088da8&scoped=true"
import script from "./insertstore.vue?vue&type=script&lang=js"
export * from "./insertstore.vue?vue&type=script&lang=js"
import style0 from "./insertstore.vue?vue&type=style&index=0&id=c9088da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9088da8",
  null
  
)

export default component.exports